const syncFailure = {
	name: 'Sync error',
	fields: {
		sync_module: 'Module',
		sync_entity_id: 'ERP no.',
		analysis: 'Problem',
		failed_at: 'Time',
	},
}

export default syncFailure
